import { render, staticRenderFns } from "./InterBeneficiaryInfo.vue?vue&type=template&id=1801cb1e"
import script from "./InterBeneficiaryInfo.vue?vue&type=script&lang=js"
export * from "./InterBeneficiaryInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports